/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/


import React, { Component } from 'react';
import { Grid, Row, Col, FormControl, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Card from 'Admin/components/Card/Card.jsx';
import { languageListAction } from 'Admin/actions/language';
import { languagechangestatusAction } from 'Admin/actions/language';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from 'react-loading';

class LanguageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            languageList: [],
            isLoading: true,
            asc_desc: true,
            userRow: null,
            currentPage: 1,
            sizePerPage: 10,
            searchText: "",
            data: {
                limit: 10,
                offset: 0,
                order: "name",
                direction: "asc",
            }
        }
        this.onPageChange = this.onPageChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.props.languageListAction(this.state.data);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.isLanguageList !== this.props.isLanguageList) {
            this.setState({
                languageList: nextProps.LanguageList.data
            });
        }

        if (this.state.isLoading == true) {
            this.setState({ isLoading: false });
        }
    }

    editButton(cell, row, enumObject, rowIndex) {
        return (<span>
            <a href="javascript:void(0)" onClick={this.statusChangedHandler.bind(this, row)}><i className={(row.status === "active") ? ('fa fa-check') : ('fa fa-remove')} aria-hidden="true"></i></a>
            {/*<a href="javascript:void(0)"><i className="fa fa-trash-o" aria-hidden="true"></i></a> */}
        </span>)
    }

    toggleEdit(event) {
        this.setState({ userRow: event });
    }

    statusChangedHandler(event, elename) {
        let newstatus = {};
        if (event.status == 'active') {
            newstatus = 'deactive';
        } else {
            newstatus = 'active';
        }
        event['id'] = event._id;
        event['status'] = newstatus;
        this.props.languagechangestatusAction(event);
    }

    _setTableOption() {
        if (this.state.isLoading) {
            return (
                <Loading type='bars' color='#000000' style={{ margin: '0px auto', width: "40px" }} />
            );
        } else {
            return "No data found!";
        }
    }

    navigateto() {
        window.location.href = "Admin/add-link";
        this.clicked = "";
    }

    goBackFun(e) {
        this.props.history.replace(sessionStorage.getItem("prvUrl"))
    }

    onPageChange(page, sizePerPage) {
        let data = {};
        data['direction'] = this.state.data.direction;
        data['order'] = this.state.data.order;
        data['offset'] = (page === -1) ? this.state.data.offset : page - 1;
        data['limit'] = sizePerPage;

        this.setState({ sizePerPage: sizePerPage })
        this.setState({ currentPage: page })
        this.props.languageListAction(data);

        if (this.state.sizePerPage !== sizePerPage || this.state.totalCount < page * sizePerPage) {
            eval('$(".ps").scrollTop(0)');
        }
    }

    sortHandle() {
        this.setState({ asc_desc: !this.state.asc_desc });
        let data = this.state.data;
        data.direction = this.state.asc_desc ? "desc" : "asc";
        this.setState({ formData: data });
        this.props.languageListAction(data);
    }

    handleSearch = (e) => {

        this.setState({ searchText: e.target.value.trimStart().replace(/\s+/g, " ") });
        this.setState({ currentPage: 1 })
    };



    render() {

        const { languageList, searchText } = this.state;

        // Filter the data based on the search text
        const filteredData = languageList.filter((item) =>
            Object.values(item).some(
                (value) => String(value).toLowerCase().includes(searchText.toLowerCase())
            )
        );

        const selectRowProp = { mode: 'checkbox' }
        const options = {
            afterDeleteRow: this.handleDeleteButtonClick,
            onSortChange: this.onSortChange,
            clearSearch: true,
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPage: this.state.sizePerPage,
            onPageChange: this.onPageChange,
            page: this.state.currentPage,
            noDataText: this._setTableOption(),
        };

        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                content={
                                    <div className="fresh-datatables table-responsive respo-T language-list-table">
                                        <Col md={4} sm={4} className="form-group search-box">
                                            <FormControl
                                                className='search_box'
                                                type="text"
                                                autocomplete="off"
                                                name="search"
                                                id="search"
                                                value={searchText}
                                                onChange={this.handleSearch}
                                                placeholder="Search"

                                            />
                                            <span className='search-span'>
                                                <Button className='search-clear' onClick={this.handleSearch}>Clear</Button>
                                            </span>
                                        </Col>
                                        <BootstrapTable selectRow="{selectRowProp}" deleteRow={false} data={filteredData} multiColumnSearch={true} pagination={true} options={options} striped hover condensed scrollTop={'Bottom'}>
                                            <TableHeaderColumn hidden={true} tdAttr={{ 'data-attr': '_id' }} dataField='invitationId' isKey searchable={false}>Id</TableHeaderColumn>
                                            <TableHeaderColumn thStyle={{ width: '20%', textAlign: 'center' }} tdStyle={{ width: '20%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Language Name' }} dataField='name' >Language Name
                                                {
                                                    this.state.asc_desc ?
                                                        <i onClick={(e) => { this.sortHandle() }} style={{ cursor: 'pointer' }} class="fa fa-caret-up" aria-hidden="true"></i> :
                                                        <i onClick={(e) => { this.sortHandle() }} style={{ cursor: 'pointer' }} class="fa fa-caret-down" aria-hidden="true"></i>
                                                }
                                            </TableHeaderColumn>
                                            <TableHeaderColumn thStyle={{ width: '20%', textAlign: 'center' }} tdStyle={{ width: '20%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Language Placeholder' }} dataField='placeholder'>Language Placeholder</TableHeaderColumn>
                                            <TableHeaderColumn thStyle={{ width: '20%', textAlign: 'center' }} tdStyle={{ width: '20%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Status' }} dataField='status'>Status</TableHeaderColumn>
                                            <TableHeaderColumn thStyle={{ width: '10%', textAlign: 'center' }} tdStyle={{ width: '10%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Action' }} dataFormat={this.editButton.bind(this)} dataSort={false}>Action</TableHeaderColumn>
                                        </BootstrapTable>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        LanguageList: state.language.LanguageList,
        isLanguageList: state.language.isLanguageList,
        isLanguageListError: state.language.isLanguageListError,
        LanguageChangeStatus: state.language.LanguageChangeStatus,
        isLanguageChangeStatus: state.language.isLanguageChangeStatus,
        isLanguageChangeStatusError: state.language.isLanguageChangeStatusError,
    }
}
export default withRouter(connect(mapStateToProps, { languageListAction, languagechangestatusAction })(LanguageList));
